import { supabase } from './supabaseClient';
import { montoParaBD } from '../utils/validacion';

import { getNegocioId } from './negocioActual';
import { fechaLocal } from '../utils/fecha';
import { CATEGORIA_COMISION } from '../utils/comisiones';

// Gastos operativos (PRODUCT_VISION cap. 6.12-6.14). Diferentes de los
// costos de producto: alimentan la utilidad real del negocio.
export async function obtenerGastos({ desde = null } = {}) {
  let query = supabase
    .from('gastos')
    .select('*')
    .eq('negocio_id', getNegocioId())
    .order('fecha', { ascending: false });
  if (desde) query = query.gte('fecha', desde);
  const { data, error } = await query;
  if (error) throw error;
  return data || [];
}

// Un gasto puntual por id (para precargar el formulario de edición).
export async function obtenerGastoPorId(id) {
  const { data, error } = await supabase
    .from('gastos')
    .select('*')
    .eq('negocio_id', getNegocioId())
    .eq('id', id)
    .single();
  if (error) throw error;
  return data;
}

// El gasto sale de una cuenta de forma atómica (función registrar_gasto).
export async function crearGasto({ categoria, descripcion, monto, cuentaId, fecha }) {
  const { data, error } = await supabase.rpc('registrar_gasto', {
    p_negocio_id: getNegocioId(),
    p_categoria: categoria,
    p_descripcion: descripcion?.trim() || null,
    p_monto: montoParaBD(monto, { nombre: 'monto del gasto' }),
    p_cuenta_id: cuentaId || null,
    p_fecha: fecha || fechaLocal(),
  });
  if (error) throw error;
  return data;
}

// Comisión bancaria automática (POS / Link de pago): un gasto que sale de la
// MISMA cuenta donde entró el cobro, para que no se ingrese a mano. Reusa
// registrar_gasto (atómico: debita la cuenta y deja el movimiento en el Balance).
export async function registrarComisionBancaria({ monto, cuentaId, fecha, detalle }) {
  return crearGasto({
    categoria: CATEGORIA_COMISION,
    descripcion: detalle || 'POS / Link de pago',
    monto,
    cuentaId,
    fecha,
  });
}

// Elimina un gasto con reverso atómico: devuelve el dinero a la cuenta
// y borra su movimiento (función eliminar_gasto).
export async function eliminarGasto(id) {
  const { error } = await supabase.rpc('eliminar_gasto', {
    p_negocio_id: getNegocioId(),
    p_referencia: String(id),
  });
  if (error) throw error;
}

// Edita un gasto: revierte el dinero viejo y aplica los datos nuevos (atómico).
export async function editarGasto(id, { categoria, descripcion, monto, cuentaId, fecha }) {
  const { data, error } = await supabase.rpc('editar_gasto', {
    p_negocio_id: getNegocioId(),
    p_referencia: String(id),
    p_categoria: categoria,
    p_descripcion: descripcion?.trim() || null,
    p_monto: montoParaBD(monto, { nombre: 'monto del gasto' }),
    p_cuenta_id: cuentaId || null,
    p_fecha: fecha || null,
  });
  if (error) throw error;
  return data;
}
